import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import axios from 'axios'
import { config } from '../config';
import { authenticator } from './Authenticator';

interface Response {
  url: string
}

class FileUploader {

  public async upload(file: File): Promise<Response> {

    var formData = new FormData();
    formData.append('file', file);

    const token = await authenticator.getToken()
    const response = await axios.post(
      `${config.serverUrl}/files`,
      formData, 
      { 
        headers: { 
          Authorization: `Bearer ${token}` 
        }
      }
    )
    return { url: response.data.url }
  }

}

export const fileUploader = new FileUploader()
